import { has } from 'lodash';
import { getPathWithArgs, pathgen } from 'object-path-generator';
import { overrideTestIds } from "./overrideTestIds";

/** @deprecated don't use this overload, use the other one instead,
 * `deprecatedTestIds` is just for backwards compatibility and lazy migration
 */

export function getTestIds(testIdOrArgs) {
  let parentTestId;
  let deprecatedTestIds;
  if (typeof testIdOrArgs === 'string' || testIdOrArgs === undefined) {
    parentTestId = testIdOrArgs;
  } else {
    parentTestId = testIdOrArgs.parentTestId;
    deprecatedTestIds = testIdOrArgs.deprecatedTestIds;
  }
  let customPathGenerator;
  if (deprecatedTestIds) {
    customPathGenerator = overrideTestIds(deprecatedTestIds);
  }
  return pathgen(undefined, function (path) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    const testId = customPathGenerator ? customPathGenerator(path, ...args) : getPathWithArgs(path, args);
    const isDeprecatedTestId = has(deprecatedTestIds, path);
    if (isDeprecatedTestId) {
      return testId;
    }
    if (parentTestId) {
      return "".concat(parentTestId, " > ").concat(testId);
    }
    return testId;
  });
}